// import React, { useState, useEffect, useRef } from 'react';
// import { Card, Button, Table, Spinner, Alert, Form, Row, Col } from 'react-bootstrap';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import * as XLSX from 'xlsx';
// import api from '../api'; // Update with your API path

// const months = [
//   'January', 'February', 'March', 'April', 'May', 'June',
//   'July', 'August', 'September', 'October', 'November', 'December'
// ];

// const currentYear = new Date().getFullYear();
// const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

// const MonthlyAnalytics = () => {
//   const [month, setMonth] = useState(new Date().getMonth() + 1);
//   const [year, setYear] = useState(currentYear);
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentDayIndex, setCurrentDayIndex] = useState(0);
//   const [exportFormat, setExportFormat] = useState('pdf');
//   const [exporting, setExporting] = useState(false);
  
//   const reportRef = useRef();
//   const dailyCardRef = useRef();

//   // Currency formatting function
//   const currencyFormat = (amount) => {
//     const numericValue = Number(amount || 0);
//     return new Intl.NumberFormat('en-KE', {
//       style: 'currency',
//       currency: 'KES',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(numericValue);
//   };

//   const profitStyle = (value) => ({
//     color: value < 0 ? '#dc3545' : '#28a745',
//     fontWeight: '500'
//   });

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await api.get(`/monthly/monthly-summary?month=${month}&year=${year}`);
      
//       const processedData = {
//         ...res.data,
//         weeklySummaries: res.data.weeklySummaries?.map(week => ({
//           ...week,
//           totalSales: Number(week.totalSales) || 0,
//           grossProfit: Number(week.grossProfit) || 0,
//           totalExpenses: Number(week.totalExpenses) || 0,
//           netProfit: Number(week.netProfit) || 0
//         })),
//         dailyBreakdown: res.data.dailyBreakdown?.map(day => ({
//           ...day,
//           formattedDate: day.date,
//           sales: Number(day.sales) || 0,
//           expenses: Number(day.expenses) || 0,
//           netProfit: (Number(day.grossProfit) || 0) - (Number(day.expenses) || 0)
//         }))
//       };
      
//       setData(processedData);
//     } catch (err) {
//       console.error('Fetch error:', err);
//       setError('Failed to load analytics data. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [month, year]);

//   const handleMonthChange = direction => {
//     let newMonth = month + direction;
//     let newYear = year;

//     if (newMonth > 12) {
//       newMonth = 1;
//       newYear++;
//     } else if (newMonth < 1) {
//       newMonth = 12;
//       newYear--;
//     }

//     setMonth(newMonth);
//     setYear(newYear);
//   };

//   const handlePrevDay = () => {
//     setCurrentDayIndex((prev) => Math.max(prev - 1, 0));
//   };
  
//   const handleNextDay = () => {
//     setCurrentDayIndex((prev) =>
//       Math.min(prev + 1, (data?.dailyBreakdown?.length || 1) - 1)
//     );
//   };

//   // Export entire report in selected format
//   const exportReport = async () => {
//     if (!reportRef.current) return;
    
//     setExporting(true);
//     const fileName = `Monthly-Report-${months[month-1]}-${year}`;
    
//     try {
//       switch(exportFormat) {
//         case 'pdf':
//           await exportToPDF(fileName);
//           break;
//         case 'excel':
//           exportToExcel(fileName);
//           break;
//         case 'csv':
//           exportToCSV(fileName);
//           break;
//         case 'image':
//           await exportToImage(fileName);
//           break;
//         default:
//           break;
//       }
//     } catch (err) {
//       console.error('Export failed:', err);
//       alert('Export failed. Please try again.');
//     } finally {
//       setExporting(false);
//     }
//   };

//   // Export to PDF
//   const exportToPDF = async (fileName) => {
//     const canvas = await html2canvas(reportRef.current, { scale: 2 });
//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');
    
//     const imgProps = pdf.getImageProperties(imgData);
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
//     // Split image into multiple pages if too tall
//     let position = 0;
//     const pageHeight = pdf.internal.pageSize.getHeight();
    
//     while (position < pdfHeight) {
//       if (position > 0) pdf.addPage();
//       pdf.addImage(imgData, 'PNG', 0, -position, pdfWidth, pdfHeight);
//       position += pageHeight;
//     }
    
//     pdf.save(`${fileName}.pdf`);
//   };

//   // Export to Excel
//   const exportToExcel = (fileName) => {
//     if (!data) return;
    
//     // Prepare data for Excel
//     const wb = XLSX.utils.book_new();
    
//     // Monthly Summary Sheet
//     const summaryData = [
//       ['Monthly Financial Summary', '', ''],
//       ['Period', `${months[month-1]}, ${year}`, ''],
//       ['Total Sales', currencyFormat(data.monthlySummary?.totalSales), ''],
//       ['Gross Profit', currencyFormat(data.monthlySummary?.grossProfit), ''],
//       ['Total Expenses', currencyFormat(data.monthlySummary?.totalExpenses), ''],
//       ['Net Profit', currencyFormat(
//         (data.monthlySummary?.grossProfit || 0) - 
//         (data.monthlySummary?.totalExpenses || 0)
//       ), '']
//     ];
    
//     const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
//     XLSX.utils.book_append_sheet(wb, summarySheet, 'Monthly Summary');
    
//     // Weekly Breakdown Sheet
//     const weeklyData = [
//       ['Week', 'Sales', 'Gross Profit', 'Expenses', 'Net Profit']
//     ];
    
//     data.weeklySummaries?.forEach(week => {
//       weeklyData.push([
//         week.weekRange,
//         currencyFormat(week.totalSales),
//         currencyFormat(week.grossProfit),
//         currencyFormat(week.totalExpenses),
//         currencyFormat(week.grossProfit - week.totalExpenses)
//       ]);
//     });
    
//     const weeklySheet = XLSX.utils.aoa_to_sheet(weeklyData);
//     XLSX.utils.book_append_sheet(wb, weeklySheet, 'Weekly Breakdown');
    
//     // Daily Breakdown Sheet
//     const dailyData = [
//       ['Date', 'Sales', 'Gross Profit', 'Expenses', 'Net Profit', 'Margin']
//     ];
    
//     data.dailyBreakdown?.forEach(day => {
//       const grossProfit = Number(day.grossProfit) || 0;
//       const expenses = Number(day.expenses) || 0;
//       const netProfit = grossProfit - expenses;
//       const margin = grossProfit !== 0 ? `${((netProfit / grossProfit) * 100).toFixed(1)}%` : '0%';
      
//       dailyData.push([
//         day.formattedDate,
//         currencyFormat(day.sales),
//         currencyFormat(grossProfit),
//         currencyFormat(expenses),
//         currencyFormat(netProfit),
//         margin
//       ]);
//     });
    
//     const dailySheet = XLSX.utils.aoa_to_sheet(dailyData);
//     XLSX.utils.book_append_sheet(wb, dailySheet, 'Daily Breakdown');
    
//     // Save the file
//     XLSX.writeFile(wb, `${fileName}.xlsx`);
//   };

//   // Export to CSV
//   const exportToCSV = (fileName) => {
//     if (!data) return;
    
//     let csvContent = "data:text/csv;charset=utf-8,";
    
//     // Monthly Summary
//     csvContent += "Monthly Financial Summary\n\n";
//     csvContent += "Period," + `${months[month-1]}, ${year}` + "\n";
//     csvContent += "Total Sales," + currencyFormat(data.monthlySummary?.totalSales) + "\n";
//     csvContent += "Gross Profit," + currencyFormat(data.monthlySummary?.grossProfit) + "\n";
//     csvContent += "Total Expenses," + currencyFormat(data.monthlySummary?.totalExpenses) + "\n";
//     csvContent += "Net Profit," + currencyFormat(
//       (data.monthlySummary?.grossProfit || 0) - 
//       (data.monthlySummary?.totalExpenses || 0)
//     ) + "\n\n";
    
//     // Weekly Breakdown
//     csvContent += "Weekly Breakdown\n\n";
//     csvContent += "Week,Sales,Gross Profit,Expenses,Net Profit\n";
    
//     data.weeklySummaries?.forEach(week => {
//       csvContent += `"${week.weekRange}",${currencyFormat(week.totalSales)},${currencyFormat(week.grossProfit)},${currencyFormat(week.totalExpenses)},${currencyFormat(week.grossProfit - week.totalExpenses)}\n`;
//     });
    
//     csvContent += "\n";
    
//     // Daily Breakdown
//     csvContent += "Daily Breakdown\n\n";
//     csvContent += "Date,Sales,Gross Profit,Expenses,Net Profit,Margin\n";
    
//     data.dailyBreakdown?.forEach(day => {
//       const grossProfit = Number(day.grossProfit) || 0;
//       const expenses = Number(day.expenses) || 0;
//       const netProfit = grossProfit - expenses;
//       const margin = grossProfit !== 0 ? `${((netProfit / grossProfit) * 100).toFixed(1)}%` : '0%';
      
//       csvContent += `${day.formattedDate},${currencyFormat(day.sales)},${currencyFormat(grossProfit)},${currencyFormat(expenses)},${currencyFormat(netProfit)},${margin}\n`;
//     });
    
//     // Create download link
//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `${fileName}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Export to Image
//   const exportToImage = async (fileName) => {
//     const canvas = await html2canvas(reportRef.current, { scale: 2 });
//     const imgData = canvas.toDataURL('image/png');
//     const link = document.createElement('a');
//     link.download = `${fileName}.png`;
//     link.href = imgData;
//     link.click();
//   };

//   // Export daily card
//   const exportDailyCard = async (format) => {
//     if (!dailyCardRef.current) return;
    
//     const fileName = `Daily-Report-${data?.dailyBreakdown?.[currentDayIndex]?.formattedDate?.replace(/,|\s+/g, '-') || 'export'}`;
    
//     try {
//       const canvas = await html2canvas(dailyCardRef.current, { scale: 2 });
      
//       if (format === 'pdf') {
//         const imgData = canvas.toDataURL('image/png');
//         const pdf = new jsPDF();
//         const imgProps = pdf.getImageProperties(imgData);
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
//         pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
//         pdf.save(`${fileName}.pdf`);
//       } else {
//         const imgData = canvas.toDataURL(`image/${format}`);
//         const link = document.createElement('a');
//         link.download = `${fileName}.${format}`;
//         link.href = imgData;
//         link.click();
//       }
//     } catch (err) {
//       console.error('Export failed:', err);
//       alert('Export failed. Please try again.');
//     }
//   };

//   return (
//     <div className="container mt-4" ref={reportRef}>
//       {/* Export Controls */}
//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <h3 className="mb-0">📊 Monthly Analytics</h3>
        
//         <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
//           <Form.Select 
//             value={exportFormat} 
//             onChange={(e) => setExportFormat(e.target.value)}
//             className="me-2"
//             style={{ width: 'auto' }}
//           >
//             <option value="pdf">PDF</option>
//             <option value="excel">Excel</option>
//             <option value="csv">CSV</option>
//             <option value="image">Image</option>
//           </Form.Select>
          
//           <Button 
//             variant="primary" 
//             onClick={exportReport}
//             disabled={exporting || !data}
//           >
//             {exporting ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 Exporting...
//               </>
//             ) : (
//               `Export Monthly Report`
//             )}
//           </Button>
//         </div>
//       </div>

//       {/* Date Controls */}
//       <Row className="align-items-center mb-4">
//         <Col xs="auto">
//           <Button variant="outline-secondary" onClick={() => handleMonthChange(-1)}>
//             ⬅️ Previous
//           </Button>
//         </Col>
//         <Col>
//           <Form.Group controlId="monthSelect">
//             <Form.Label>Month</Form.Label>
//             <Form.Select value={month} onChange={e => setMonth(Number(e.target.value))}>
//               {months.map((m, idx) => (
//                 <option key={m} value={idx + 1}>{m}</option>
//               ))}
//             </Form.Select>
//           </Form.Group>
//         </Col>
//         <Col>
//           <Form.Group controlId="yearSelect">
//             <Form.Label>Year</Form.Label>
//             <Form.Select value={year} onChange={e => setYear(Number(e.target.value))}>
//               {yearOptions.map(y => (
//                 <option key={y} value={y}>{y}</option>
//               ))}
//             </Form.Select>
//           </Form.Group>
//         </Col>
//         <Col xs="auto">
//           <Button variant="outline-secondary" onClick={() => handleMonthChange(1)}>
//             Next ➡️
//           </Button>
//         </Col>
//       </Row>

//       {/* Loading and Error States */}
//       {loading && (
//         <div className="text-center p-4">
//           <Spinner animation="border" variant="primary" />
//           <p className="mt-2">Loading analytics data...</p>
//         </div>
//       )}

//       {error && (
//         <Alert variant="danger" className="mt-3">
//           {error}
//         </Alert>
//       )}

//       {/* Data Display */}
//       {data && !loading && !error && (
//         <>
//           {/* Summary Section */}
//           <Card className="shadow-sm mb-4 border-0">
//             <Card.Header className="bg-primary text-white text-center fs-5 fw-semibold">
//               Monthly Financial Summary
//             </Card.Header>
//             <Card.Body className="bg-light">
//               <Row className="mb-3">
//                 <Col xs={4} className="fw-bold text-muted">Period</Col>
//                 <Col xs={8} className="text-dark">
//                   {months[month - 1]}, {year}
//                 </Col>
//               </Row>

//               <Row className="mb-2">
//                 <Col xs={4} className="fw-bold text-secondary">Total Sales</Col>
//                 <Col xs={8} className="text-secondary">
//                   {currencyFormat(data.monthlySummary?.totalSales)}
//                 </Col>
//               </Row>

//               <Row className="mb-2">
//                 <Col xs={4} className="fw-bold text-success">Gross Profit</Col>
//                 <Col xs={8} className="text-success">
//                   {currencyFormat(data.monthlySummary?.grossProfit)}
//                 </Col>
//               </Row>

//               <Row className="mb-2">
//                 <Col xs={4} className="fw-bold text-danger">Total Expenses</Col>
//                 <Col xs={8} className="text-danger">
//                   {currencyFormat(data.monthlySummary?.totalExpenses)}
//                 </Col>
//               </Row>

//               <hr />

//               <Row>
//                 <Col xs={4} className="fw-bold text-primary">Net Profit</Col>
//                 <Col 
//                   xs={8}
//                   style={profitStyle(
//                     data.monthlySummary?.grossProfit - data.monthlySummary?.totalExpenses
//                   )}
//                   className="fw-semibold"
//                 >
//                   {currencyFormat(
//                     (data.monthlySummary?.grossProfit || 0) -
//                     (data.monthlySummary?.totalExpenses || 0)
//                   )}
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>

//           {/* Weekly Summary */}
//           <h4 className="section-title mt-5">Weekly Breakdown</h4>
//           <Card className="mb-4 shadow-sm">
//             <Card.Body>
//               <Table responsive striped hover className="align-middle">
//                 <thead className="table-dark">
//                   <tr>
//                     <th>Week</th>
//                     <th className="text-end">Sales</th>
//                     <th className="text-end">Gross Profit</th>
//                     <th className="text-end">Expenses</th>
//                     <th className="text-end">Net Profit</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.weeklySummaries?.map((week, index) => (
//                     <tr key={index}>
//                       <td>{week.weekRange}</td>
//                       <td className="text-end">{currencyFormat(week.totalSales)}</td>
//                       <td className="text-end text-success">
//                         {currencyFormat(week.grossProfit)}
//                       </td>
//                       <td className="text-end text-danger">
//                         {currencyFormat(week.totalExpenses)}
//                       </td>
//                       <td className="text-end" style={profitStyle(week.grossProfit - week.totalExpenses)}>
//                         {currencyFormat(week.grossProfit - week.totalExpenses)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>

//           {/* Daily Details */}
//           <h4 className="section-title mt-5">Daily Details</h4>
//           <div className="d-flex justify-content-between align-items-center mb-3">
//             <Button 
//               variant="outline-secondary" 
//               onClick={handlePrevDay} 
//               disabled={currentDayIndex === 0}
//             >
//               ← Previous Day
//             </Button>
//             <span className="text-muted">
//               {currentDayIndex + 1} of {data?.dailyBreakdown?.length || 0}
//             </span>
//             <Button 
//               variant="outline-secondary" 
//               onClick={handleNextDay} 
//               disabled={currentDayIndex >= (data?.dailyBreakdown?.length || 0) - 1}
//             >
//               Next Day →
//             </Button>
//           </div>

//           <div className="d-flex justify-content-end gap-2 mb-2">
//             <Button variant="outline-primary" onClick={() => exportDailyCard('pdf')}>
//               Export PDF
//             </Button>
//             <Button variant="outline-success" onClick={() => exportDailyCard('png')}>
//               Export Image
//             </Button>
//           </div>

//           <Card className="shadow-sm" ref={dailyCardRef}>
//             <Card.Body>
//               <Table responsive bordered>
//                 <tbody>
//                   {data?.dailyBreakdown?.[currentDayIndex] && (() => {
//                     const dailyData = data.dailyBreakdown[currentDayIndex];
//                     const grossProfit = Number(dailyData.grossProfit) || 0;
//                     const expenses = Number(dailyData.expenses) || 0;
//                     const netProfit = grossProfit - expenses;

//                     return (
//                       <>
//                         <tr>
//                           <td><strong>Date</strong></td>
//                           <td>{dailyData.formattedDate}</td>
//                         </tr>
//                         <tr>
//                           <td><strong>Total Sales</strong></td>
//                           <td className="text-end">{currencyFormat(dailyData.sales)}</td>
//                         </tr>
//                         <tr>
//                           <td><strong>Gross Profit</strong></td>
//                           <td className="text-end text-success">
//                             {currencyFormat(grossProfit)}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td><strong>Total Expenses</strong></td>
//                           <td className="text-end text-danger">
//                             {currencyFormat(expenses)}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td><strong>Net Profit</strong></td>
//                           <td 
//                             className="text-end" 
//                             style={profitStyle(netProfit)}
//                           >
//                             {currencyFormat(netProfit)}
//                             <div className="text-muted small mt-1">
//                               (Gross Profit - Expenses)
//                             </div>
//                           </td>
//                         </tr>
//                       </>
//                     );
//                   })()}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>

//           {/* Daily Breakdown Section */}
//           <h4 className="section-title mt-5">Daily Transactions</h4>
//           <Card className="shadow-sm mt-3">
//             <Card.Body>
//               <Table responsive bordered hover className="align-middle">
//                 <thead className="table-light">
//                   <tr>
//                     <th>Date</th>
//                     <th className="text-end">Sales</th>
//                     <th className="text-end">Gross Profit</th>
//                     <th className="text-end">Expenses</th>
//                     <th className="text-end">Net Profit</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.dailyBreakdown?.map((day, index) => {
//                     const grossProfit = Number(day.grossProfit) || 0;
//                     const expenses = Number(day.expenses) || 0;
//                     const netProfit = grossProfit - expenses;

//                     return (
//                       <tr key={index}>
//                         <td>{day.formattedDate}</td>
//                         <td className="text-end">{currencyFormat(day.sales)}</td>
//                         <td className="text-end text-success">
//                           {currencyFormat(grossProfit)}
//                         </td>
//                         <td className="text-end text-danger">
//                           {currencyFormat(expenses)}
//                         </td>
//                         <td className="text-end" style={profitStyle(netProfit)}>
//                           {currencyFormat(netProfit)}
//                           <div className="text-muted small mt-1">
//                             Margin: {grossProfit !== 0 
//                               ? `${((netProfit / grossProfit) * 100).toFixed(1)}%` 
//                               : '0%'}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </>
//       )}
//     </div>
//   );
// };

// export default MonthlyAnalytics;

import React, { useState, useEffect, useRef } from 'react';
import { 
  Card, Button, Table, Spinner, Alert, Form, 
  Row, Col, Dropdown, InputGroup, Badge, ListGroup
} from 'react-bootstrap';
import { 
  ArrowLeft, ArrowRight, Download, FileEarmarkPdf, 
  FileEarmarkExcel, FileEarmarkText, Image,
  Calendar, ChevronLeft, ChevronRight, CashStack, GraphUp
} from 'react-bootstrap-icons';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import api from '../api';
import './MonthlyAnalytics.css';

// Custom hook for mobile detection
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return isMobile;
};

const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

const MonthlyAnalytics = () => {
  const isMobile = useIsMobile();
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(currentYear);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const [exporting, setExporting] = useState(false);
  
  const reportRef = useRef();
  const dailyCardRef = useRef();

  // Currency formatting function
  const currencyFormat = (amount) => {
    const numericValue = Number(amount || 0);
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numericValue);
  };

  const profitStyle = (value) => ({
    color: value < 0 ? '#dc3545' : '#28a745',
    fontWeight: '500'
  });

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/monthly/monthly-summary?month=${month}&year=${year}`);
      
      const processedData = {
        ...res.data,
        weeklySummaries: res.data.weeklySummaries?.map(week => ({
          ...week,
          totalSales: Number(week.totalSales) || 0,
          grossProfit: Number(week.grossProfit) || 0,
          totalExpenses: Number(week.totalExpenses) || 0,
          netProfit: Number(week.netProfit) || 0
        })),
        dailyBreakdown: res.data.dailyBreakdown?.map(day => ({
          ...day,
          formattedDate: day.date,
          sales: Number(day.sales) || 0,
          expenses: Number(day.expenses) || 0,
          netProfit: (Number(day.grossProfit) || 0) - (Number(day.expenses) || 0)
        }))
      };
      
      setData(processedData);
    } catch (err) {
      console.error('Fetch error:', err);
      setError('Failed to load analytics data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [month, year]);

  const handleMonthChange = direction => {
    let newMonth = month + direction;
    let newYear = year;

    if (newMonth > 12) {
      newMonth = 1;
      newYear++;
    } else if (newMonth < 1) {
      newMonth = 12;
      newYear--;
    }

    setMonth(newMonth);
    setYear(newYear);
  };

  const handlePrevDay = () => {
    setCurrentDayIndex((prev) => Math.max(prev - 1, 0));
  };
  
  const handleNextDay = () => {
    setCurrentDayIndex((prev) =>
      Math.min(prev + 1, (data?.dailyBreakdown?.length || 1) - 1)
    );
  };

  // Export entire report in selected format
  const exportReport = async (format) => {
    if (!reportRef.current) return;
    
    setExporting(true);
    const fileName = `Monthly-Report-${months[month-1]}-${year}`;
    
    try {
      switch(format) {
        case 'pdf':
          await exportToPDF(fileName);
          break;
        case 'excel':
          exportToExcel(fileName);
          break;
        case 'csv':
          exportToCSV(fileName);
          break;
        case 'image':
          await exportToImage(fileName);
          break;
        default:
          break;
      }
    } catch (err) {
      console.error('Export failed:', err);
      alert('Export failed. Please try again.');
    } finally {
      setExporting(false);
    }
  };

  // Export to PDF
  const exportToPDF = async (fileName) => {
    const canvas = await html2canvas(reportRef.current, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
    // Split image into multiple pages if too tall
    let position = 0;
    const pageHeight = pdf.internal.pageSize.getHeight();
    
    while (position < pdfHeight) {
      if (position > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, -position, pdfWidth, pdfHeight);
      position += pageHeight;
    }
    
    pdf.save(`${fileName}.pdf`);
  };

  // Export to Excel
  const exportToExcel = (fileName) => {
    if (!data) return;
    
    // Prepare data for Excel
    const wb = XLSX.utils.book_new();
    
    // Monthly Summary Sheet
    const summaryData = [
      ['Monthly Financial Summary', '', ''],
      ['Period', `${months[month-1]}, ${year}`, ''],
      ['Total Sales', currencyFormat(data.monthlySummary?.totalSales), ''],
      ['Gross Profit', currencyFormat(data.monthlySummary?.grossProfit), ''],
      ['Total Expenses', currencyFormat(data.monthlySummary?.totalExpenses), ''],
      ['Net Profit', currencyFormat(
        (data.monthlySummary?.grossProfit || 0) - 
        (data.monthlySummary?.totalExpenses || 0)
      ), '']
    ];
    
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    XLSX.utils.book_append_sheet(wb, summarySheet, 'Monthly Summary');
    
    // Weekly Breakdown Sheet
    const weeklyData = [
      ['Week', 'Sales', 'Gross Profit', 'Expenses', 'Net Profit']
    ];
    
    data.weeklySummaries?.forEach(week => {
      weeklyData.push([
        week.weekRange,
        currencyFormat(week.totalSales),
        currencyFormat(week.grossProfit),
        currencyFormat(week.totalExpenses),
        currencyFormat(week.grossProfit - week.totalExpenses)
      ]);
    });
    
    const weeklySheet = XLSX.utils.aoa_to_sheet(weeklyData);
    XLSX.utils.book_append_sheet(wb, weeklySheet, 'Weekly Breakdown');
    
    // Daily Breakdown Sheet
    const dailyData = [
      ['Date', 'Sales', 'Gross Profit', 'Expenses', 'Net Profit', 'Margin']
    ];
    
    data.dailyBreakdown?.forEach(day => {
      const grossProfit = Number(day.grossProfit) || 0;
      const expenses = Number(day.expenses) || 0;
      const netProfit = grossProfit - expenses;
      const margin = grossProfit !== 0 ? `${((netProfit / grossProfit) * 100).toFixed(1)}%` : '0%';
      
      dailyData.push([
        day.formattedDate,
        currencyFormat(day.sales),
        currencyFormat(grossProfit),
        currencyFormat(expenses),
        currencyFormat(netProfit),
        margin
      ]);
    });
    
    const dailySheet = XLSX.utils.aoa_to_sheet(dailyData);
    XLSX.utils.book_append_sheet(wb, dailySheet, 'Daily Breakdown');
    
    // Save the file
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  // Export to CSV
  const exportToCSV = (fileName) => {
    if (!data) return;
    
    let csvContent = "data:text/csv;charset=utf-8,";
    
    // Monthly Summary
    csvContent += "Monthly Financial Summary\n\n";
    csvContent += "Period," + `${months[month-1]}, ${year}` + "\n";
    csvContent += "Total Sales," + currencyFormat(data.monthlySummary?.totalSales) + "\n";
    csvContent += "Gross Profit," + currencyFormat(data.monthlySummary?.grossProfit) + "\n";
    csvContent += "Total Expenses," + currencyFormat(data.monthlySummary?.totalExpenses) + "\n";
    csvContent += "Net Profit," + currencyFormat(
      (data.monthlySummary?.grossProfit || 0) - 
      (data.monthlySummary?.totalExpenses || 0)
    ) + "\n\n";
    
    // Weekly Breakdown
    csvContent += "Weekly Breakdown\n\n";
    csvContent += "Week,Sales,Gross Profit,Expenses,Net Profit\n";
    
    data.weeklySummaries?.forEach(week => {
      csvContent += `"${week.weekRange}",${currencyFormat(week.totalSales)},${currencyFormat(week.grossProfit)},${currencyFormat(week.totalExpenses)},${currencyFormat(week.grossProfit - week.totalExpenses)}\n`;
    });
    
    csvContent += "\n";
    
    // Daily Breakdown
    csvContent += "Daily Breakdown\n\n";
    csvContent += "Date,Sales,Gross Profit,Expenses,Net Profit,Margin\n";
    
    data.dailyBreakdown?.forEach(day => {
      const grossProfit = Number(day.grossProfit) || 0;
      const expenses = Number(day.expenses) || 0;
      const netProfit = grossProfit - expenses;
      const margin = grossProfit !== 0 ? `${((netProfit / grossProfit) * 100).toFixed(1)}%` : '0%';
      
      csvContent += `${day.formattedDate},${currencyFormat(day.sales)},${currencyFormat(grossProfit)},${currencyFormat(expenses)},${currencyFormat(netProfit)},${margin}\n`;
    });
    
    // Create download link
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Export to Image
  const exportToImage = async (fileName) => {
    const canvas = await html2canvas(reportRef.current, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `${fileName}.png`;
    link.href = imgData;
    link.click();
  };

  // Export daily card
  const exportDailyCard = async (format) => {
    if (!dailyCardRef.current) return;
    
    const fileName = `Daily-Report-${data?.dailyBreakdown?.[currentDayIndex]?.formattedDate?.replace(/,|\s+/g, '-') || 'export'}`;
    
    try {
      const canvas = await html2canvas(dailyCardRef.current, { scale: 2 });
      
      if (format === 'pdf') {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${fileName}.pdf`);
      } else {
        const imgData = canvas.toDataURL(`image/${format}`);
        const link = document.createElement('a');
        link.download = `${fileName}.${format}`;
        link.href = imgData;
        link.click();
      }
    } catch (err) {
      console.error('Export failed:', err);
      alert('Export failed. Please try again.');
    }
  };

  const MobileSummaryCard = () => (
    <Card className="shadow-sm mb-3 border-0">
      <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
        <div>
          <GraphUp size={18} className="me-2" />
          <span className="fw-semibold">Monthly Summary</span>
        </div>
        <div className="small">
          {months[month - 1]}, {year}
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <ListGroup variant="flush">
          <ListGroup.Item className="d-flex justify-content-between py-2">
            <span className="text-muted">Total Sales</span>
            <span>{currencyFormat(data.monthlySummary?.totalSales)}</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between py-2">
            <span className="text-success">Gross Profit</span>
            <span className="text-success">
              {currencyFormat(data.monthlySummary?.grossProfit)}
            </span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between py-2">
            <span className="text-danger">Total Expenses</span>
            <span className="text-danger">
              {currencyFormat(data.monthlySummary?.totalExpenses)}
            </span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between py-2 fw-bold">
            <span>Net Profit</span>
            <span style={profitStyle(
              data.monthlySummary?.grossProfit - data.monthlySummary?.totalExpenses
            )}>
              {currencyFormat(
                (data.monthlySummary?.grossProfit || 0) -
                (data.monthlySummary?.totalExpenses || 0)
              )}
            </span>
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );

  const MobileWeeklySummary = () => (
    <Card className="shadow-sm mb-3">
      <Card.Header className="bg-light fw-semibold">
        Weekly Breakdown
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table bordered hover className="mb-0">
            <thead>
              <tr>
                <th>Week</th>
                <th className="text-end">Sales</th>
                <th className="text-end">Gross Profit</th>
                <th className="text-end">Expenses</th>
                <th className="text-end">Net Profit</th>
              </tr>
            </thead>
            <tbody>
              {data.weeklySummaries?.map((week, index) => (
                <tr key={index}>
                  <td>{week.weekRange}</td>
                  <td className="text-end">{currencyFormat(week.totalSales)}</td>
                  <td className="text-end text-success">
                    {currencyFormat(week.grossProfit)}
                  </td>
                  <td className="text-end text-danger">
                    {currencyFormat(week.totalExpenses)}
                  </td>
                  <td className="text-end" style={profitStyle(week.grossProfit - week.totalExpenses)}>
                    {currencyFormat(week.grossProfit - week.totalExpenses)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );

  const MobileDailyDetails = () => {
    if (!data?.dailyBreakdown?.[currentDayIndex]) return null;
    
    const dailyData = data.dailyBreakdown[currentDayIndex];
    const grossProfit = Number(dailyData.grossProfit) || 0;
    const expenses = Number(dailyData.expenses) || 0;
    const netProfit = grossProfit - expenses;

    return (
      <Card className="shadow-sm mb-3" ref={dailyCardRef}>
        <Card.Header className="bg-light fw-semibold d-flex justify-content-between">
          <div>Daily Details</div>
          <div className="small">
            {currentDayIndex + 1} of {data.dailyBreakdown.length}
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          <ListGroup variant="flush">
            <ListGroup.Item className="d-flex justify-content-between py-2">
              <span className="text-muted">Date</span>
              <span>{dailyData.formattedDate}</span>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between py-2">
              <span className="text-muted">Total Sales</span>
              <span>{currencyFormat(dailyData.sales)}</span>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between py-2">
              <span className="text-success">Gross Profit</span>
              <span className="text-success">
                {currencyFormat(grossProfit)}
              </span>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between py-2">
              <span className="text-danger">Total Expenses</span>
              <span className="text-danger">
                {currencyFormat(expenses)}
              </span>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between py-2 fw-bold">
              <span>Net Profit</span>
              <span style={profitStyle(netProfit)}>
                {currencyFormat(netProfit)}
              </span>
            </ListGroup.Item>
          </ListGroup>
        </Card.Body>
        <Card.Footer className="d-flex justify-content-between py-2">
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={handlePrevDay} 
            disabled={currentDayIndex === 0}
          >
            <ChevronLeft size={16} /> Prev
          </Button>
          <div className="d-flex gap-1">
            <Button variant="outline-primary" size="sm" onClick={() => exportDailyCard('pdf')}>
              <FileEarmarkPdf size={14} />
            </Button>
            <Button variant="outline-success" size="sm" onClick={() => exportDailyCard('png')}>
              <Image size={14} />
            </Button>
          </div>
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={handleNextDay} 
            disabled={currentDayIndex >= data.dailyBreakdown.length - 1}
          >
            Next <ChevronRight size={16} />
          </Button>
        </Card.Footer>
      </Card>
    );
  };

  const MobileDailyTransactions = () => (
    <Card className="shadow-sm">
      <Card.Header className="bg-light fw-semibold">
        Daily Transactions
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table bordered hover className="mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th className="text-end">Sales</th>
                <th className="text-end">Gross Profit</th>
                <th className="text-end">Expenses</th>
                <th className="text-end">Net Profit</th>
              </tr>
            </thead>
            <tbody>
              {data.dailyBreakdown?.map((day, index) => {
                const grossProfit = Number(day.grossProfit) || 0;
                const expenses = Number(day.expenses) || 0;
                const netProfit = grossProfit - expenses;

                return (
                  <tr key={index}>
                    <td>{day.formattedDate}</td>
                    <td className="text-end">{currencyFormat(day.sales)}</td>
                    <td className="text-end text-success">
                      {currencyFormat(grossProfit)}
                    </td>
                    <td className="text-end text-danger">
                      {currencyFormat(expenses)}
                    </td>
                    <td className="text-end" style={profitStyle(netProfit)}>
                      {currencyFormat(netProfit)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );

  const DesktopSummaryCard = () => (
    <Card className="shadow-sm mb-4 border-0">
      <Card.Header className="bg-primary text-white text-center fs-5 fw-semibold">
        Monthly Financial Summary
      </Card.Header>
      <Card.Body className="bg-light">
        <Row className="mb-3">
          <Col xs={4} className="fw-bold text-muted">Period</Col>
          <Col xs={8} className="text-dark">
            {months[month - 1]}, {year}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={4} className="fw-bold text-secondary">Total Sales</Col>
          <Col xs={8} className="text-secondary">
            {currencyFormat(data.monthlySummary?.totalSales)}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={4} className="fw-bold text-success">Gross Profit</Col>
          <Col xs={8} className="text-success">
            {currencyFormat(data.monthlySummary?.grossProfit)}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={4} className="fw-bold text-danger">Total Expenses</Col>
          <Col xs={8} className="text-danger">
            {currencyFormat(data.monthlySummary?.totalExpenses)}
          </Col>
        </Row>

        <hr />

        <Row>
          <Col xs={4} className="fw-bold text-primary">Net Profit</Col>
          <Col 
            xs={8}
            style={profitStyle(
              data.monthlySummary?.grossProfit - data.monthlySummary?.totalExpenses
            )}
            className="fw-semibold"
          >
            {currencyFormat(
              (data.monthlySummary?.grossProfit || 0) -
              (data.monthlySummary?.totalExpenses || 0)
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const DesktopWeeklySummary = () => (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-light fw-semibold fs-5">
        Weekly Breakdown
      </Card.Header>
      <Card.Body>
        <Table responsive striped hover className="align-middle">
          <thead className="table-light">
            <tr>
              <th>Week</th>
              <th className="text-end">Sales</th>
              <th className="text-end">Gross Profit</th>
              <th className="text-end">Expenses</th>
              <th className="text-end">Net Profit</th>
            </tr>
          </thead>
          <tbody>
            {data.weeklySummaries?.map((week, index) => (
              <tr key={index}>
                <td>{week.weekRange}</td>
                <td className="text-end">{currencyFormat(week.totalSales)}</td>
                <td className="text-end text-success">
                  {currencyFormat(week.grossProfit)}
                </td>
                <td className="text-end text-danger">
                  {currencyFormat(week.totalExpenses)}
                </td>
                <td className="text-end" style={profitStyle(week.grossProfit - week.totalExpenses)}>
                  {currencyFormat(week.grossProfit - week.totalExpenses)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );

  const DesktopDailyDetails = () => (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="section-title">Daily Details</h4>
        <div className="d-flex gap-2">
          <Button 
            variant="outline-secondary" 
            onClick={handlePrevDay} 
            disabled={currentDayIndex === 0}
          >
            ← Previous Day
          </Button>
          <span className="text-muted mx-2">
            {currentDayIndex + 1} of {data?.dailyBreakdown?.length || 0}
          </span>
          <Button 
            variant="outline-secondary" 
            onClick={handleNextDay} 
            disabled={currentDayIndex >= (data?.dailyBreakdown?.length || 0) - 1}
          >
            Next Day →
          </Button>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2 mb-2">
        <Button variant="outline-primary" onClick={() => exportDailyCard('pdf')}>
          Export PDF
        </Button>
        <Button variant="outline-success" onClick={() => exportDailyCard('png')}>
          Export Image
        </Button>
      </div>

      <Card className="shadow-sm" ref={dailyCardRef}>
        <Card.Body>
          <Table responsive bordered>
            <tbody>
              {data?.dailyBreakdown?.[currentDayIndex] && (() => {
                const dailyData = data.dailyBreakdown[currentDayIndex];
                const grossProfit = Number(dailyData.grossProfit) || 0;
                const expenses = Number(dailyData.expenses) || 0;
                const netProfit = grossProfit - expenses;

                return (
                  <>
                    <tr>
                      <td><strong>Date</strong></td>
                      <td>{dailyData.formattedDate}</td>
                    </tr>
                    <tr>
                      <td><strong>Total Sales</strong></td>
                      <td className="text-end">{currencyFormat(dailyData.sales)}</td>
                    </tr>
                    <tr>
                      <td><strong>Gross Profit</strong></td>
                      <td className="text-end text-success">
                        {currencyFormat(grossProfit)}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Total Expenses</strong></td>
                      <td className="text-end text-danger">
                        {currencyFormat(expenses)}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Net Profit</strong></td>
                      <td 
                        className="text-end" 
                        style={profitStyle(netProfit)}
                      >
                        {currencyFormat(netProfit)}
                        <div className="text-muted small mt-1">
                          (Gross Profit - Expenses)
                        </div>
                      </td>
                    </tr>
                  </>
                );
              })()}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );

  const DesktopDailyTransactions = () => (
    <>
      <h4 className="section-title mt-5">Daily Transactions</h4>
      <Card className="shadow-sm mt-3">
        <Card.Body>
          <Table responsive bordered hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th className="text-end">Sales</th>
                <th className="text-end">Gross Profit</th>
                <th className="text-end">Expenses</th>
                <th className="text-end">Net Profit</th>
              </tr>
            </thead>
            <tbody>
              {data.dailyBreakdown?.map((day, index) => {
                const grossProfit = Number(day.grossProfit) || 0;
                const expenses = Number(day.expenses) || 0;
                const netProfit = grossProfit - expenses;

                return (
                  <tr key={index}>
                    <td>{day.formattedDate}</td>
                    <td className="text-end">{currencyFormat(day.sales)}</td>
                    <td className="text-end text-success">
                      {currencyFormat(grossProfit)}
                    </td>
                    <td className="text-end text-danger">
                      {currencyFormat(expenses)}
                    </td>
                    <td className="text-end" style={profitStyle(netProfit)}>
                      {currencyFormat(netProfit)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );

  return (
    <div className={`mt-2 px-${isMobile ? '2' : '4'}`} ref={reportRef}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 fs-5">
          <GraphUp size={20} className="me-2" />
          Monthly Analytics
        </h3>
        
        <Dropdown>
          <Dropdown.Toggle variant="primary" size="sm">
            <Download size={16} className="me-1" /> 
            {isMobile ? 'Export' : 'Export Report'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => exportReport('pdf')}>
              <FileEarmarkPdf className="me-2 text-danger" /> PDF
            </Dropdown.Item>
            <Dropdown.Item onClick={() => exportReport('excel')}>
              <FileEarmarkExcel className="me-2 text-success" /> Excel
            </Dropdown.Item>
            <Dropdown.Item onClick={() => exportReport('csv')}>
              <FileEarmarkText className="me-2 text-primary" /> CSV
            </Dropdown.Item>
            <Dropdown.Item onClick={() => exportReport('image')}>
              <Image className="me-2 text-info" /> Image
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {exporting && (
        <Alert variant="info" className="py-2 small d-flex align-items-center">
          <Spinner animation="border" size="sm" className="me-2" />
          Exporting report, please wait...
        </Alert>
      )}

      {/* Date Controls */}
      <Card className="mb-3 shadow-sm">
        <Card.Body className="p-2">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Button 
              variant="outline-secondary" 
              size={isMobile ? "sm" : undefined}
              onClick={() => handleMonthChange(-1)}
            >
              <ChevronLeft size={isMobile ? 14 : 16} /> 
              {!isMobile && 'Previous'}
            </Button>
            
            <div className="text-center">
              <div className="fw-bold">{months[month - 1]}, {year}</div>
              <div className="small text-muted">Monthly Report</div>
            </div>
            
            <Button 
              variant="outline-secondary" 
              size={isMobile ? "sm" : undefined}
              onClick={() => handleMonthChange(1)}
            >
              {!isMobile && 'Next'} 
              <ChevronRight size={isMobile ? 14 : 16} />
            </Button>
          </div>
          
          <div className="d-flex gap-2">
            <Form.Select 
              value={month} 
              onChange={e => setMonth(Number(e.target.value))}
              size={isMobile ? "sm" : undefined}
            >
              {months.map((m, idx) => (
                <option key={m} value={idx + 1}>{m}</option>
              ))}
            </Form.Select>
            
            <Form.Select 
              value={year} 
              onChange={e => setYear(Number(e.target.value))}
              size={isMobile ? "sm" : undefined}
            >
              {yearOptions.map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </Form.Select>
          </div>
        </Card.Body>
      </Card>

      {/* Loading and Error States */}
      {loading && (
        <div className="text-center p-4">
          <Spinner animation="border" variant="primary" size={isMobile ? "sm" : undefined} />
          <p className="mt-2 small">Loading analytics data...</p>
        </div>
      )}

      {error && (
        <Alert variant="danger" className="py-2 small">
          {error}
        </Alert>
      )}

      {/* Data Display */}
      {data && !loading && !error && (
        <>
          {isMobile ? (
            <>
              <MobileSummaryCard />
              <MobileWeeklySummary />
              <MobileDailyDetails />
              <MobileDailyTransactions />
            </>
          ) : (
            <>
              <DesktopSummaryCard />
              <DesktopWeeklySummary />
              <DesktopDailyDetails />
              <DesktopDailyTransactions />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default MonthlyAnalytics;